import { tv, type VariantProps } from "tailwind-variants"
export type DisabledVariantProps = VariantProps<typeof disabledVariants>

export const disabledVariants = tv({
  base: "disabled:pointer-events-none disabled:opacity-40",
  variants: {
    disabled: {
      true: "pointer-events-none opacity-40",
    },
  },
})
